'use client';
import { useEffect } from 'react';
 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import ServiceDetailCards from'./components/ServiceDetailCards';
 import ProcessFlow from'./components/ProcessFlow';
 import Link from'next/link';

export default function ServicesPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="pt-32">
        {/* Page Header */}
        <section className="pb-20 bg-background">
          <div className="max-w-5xl mx-auto px-6 text-center reveal">
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="w-[2px] h-4 bg-amber-500" />
              <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
                Our Services
              </span>
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-8 text-white">
              Digital Solutions<br />for Every Need
            </h1>
            <p className="text-lg md:text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed">
              From social media marketing to complete digital transformations, we offer comprehensive services designed to elevate your brand.
            </p>
          </div>
        </section>

        <ServiceDetailCards />
        <ProcessFlow />

        {/* CTA Section */}
        <section className="py-20 md:py-32 bg-background">
          <div className="max-w-4xl mx-auto px-6 text-center reveal">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-white">
              Ready to Get Started?
            </h2>
            <p className="text-lg text-zinc-400 mb-8 max-w-2xl mx-auto">
              Let's discuss which services are right for your business and create a custom plan.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/contact"
                className="px-8 py-4 bg-amber-500 text-white rounded-xl hover:bg-amber-600 transition-all shadow-lg hover:shadow-amber-500/50 font-semibold"
              >
                Contact Us Today
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}